// Strings for the emptyStates screens brought over from the app (pinto). One namespace
// per file so features can be edited independently; merged in parity/index.ts.
// Mirrors pinto's scanning.*, guide.*, alerts.howto_* / sample_*, feed.tab_* and contact.* keys.
export const emptyStatesEn = {
  emptyStates: {
    scanning: {
      title: "Scanning your stores",
      body: "Your first deals land within 24 hours.",
      meanwhile: "MEANWHILE",
      leadsTitle: "Browse leads",
      leadsSub: "See if they're at a store near you",
      searchTitle: "Search a product",
      searchSub: "Check its price at your stores",
    },
    guide: {
      title: "How to read a deal",
      sub: "Every card shows the same four things.",
      markdown: "How much off",
      price: "Clearance price",
      store: "Which store has it",
      stock: "How many are left",
      tap: "Tap any deal to see the aisle and check stock nearby.",
      gotIt: "Got it",
    },
    alerts: {
      title: "No alerts yet",
      note: "Get a heads-up when a deal's price drops or it's back in stock.",
      sampleTime: "now",
      sampleBefore: "Hoover SmartWash Pet dropped to",
      sampleAfter: "at Walmart #3104. 4 left.",
      howtoInline: "Open a deal and tap",
      alertPill: "Alert",
      seeDeals: "See deals",
    },
    feed: {
      tabPennyShort: "Penny",
      tabCoupons: "Coupons",
    },
    help: {
      menuLabel: "Help",
      title: "Contact Us",
      subtitle: "Questions, problems or billing? We're here to help.",
      chat: "Chat with us",
      chatSub: "Fastest. We usually reply within a few hours.",
      emailUs: "Email us",
      emailSubject: "DealHawk support",
      diagAccount: "Account",
      discordSub: "Ask the team and other members",
      copyEmail: "Copy {{email}}",
      copied: "Email copied",
      faq: "Common questions",
      faqSub: "Quick answers about stores, deals and billing",
    },
  },
};

export const emptyStatesEs: typeof emptyStatesEn = {
  emptyStates: {
    scanning: {
      title: "Estamos revisando tus tiendas",
      body: "Tus primeras ofertas llegan en menos de 24 horas.",
      meanwhile: "MIENTRAS TANTO",
      leadsTitle: "Explora los leads",
      leadsSub: "Mira si están en una tienda cerca de ti",
      searchTitle: "Busca un producto",
      searchSub: "Mira su precio en tus tiendas",
    },
    guide: {
      title: "Cómo leer una oferta",
      sub: "Cada tarjeta muestra las mismas cuatro cosas.",
      markdown: "Cuánto descuento",
      price: "Precio de liquidación",
      store: "Qué tienda lo tiene",
      stock: "Cuántos quedan",
      tap: "Toca cualquier oferta para ver el pasillo y revisar existencias cerca.",
      gotIt: "Entendido",
    },
    alerts: {
      title: "Aún no hay alertas",
      note: "Te avisamos cuando una oferta baje de precio o vuelva a haber existencias.",
      sampleTime: "ahora",
      sampleBefore: "Hoover SmartWash Pet bajó a",
      sampleAfter: "en Walmart #3104. Quedan 4.",
      howtoInline: "Abre una oferta y toca",
      alertPill: "Alerta",
      seeDeals: "Ver ofertas",
    },
    feed: {
      tabPennyShort: "Penny",
      tabCoupons: "Cupones",
    },
    help: {
      menuLabel: "Ayuda",
      title: "Contáctanos",
      subtitle: "¿Preguntas, problemas o facturación? Estamos para ayudarte.",
      chat: "Chatea con nosotros",
      chatSub: "Lo más rápido. Respondemos en unas horas.",
      emailUs: "Escríbenos",
      emailSubject: "Soporte DealHawk",
      diagAccount: "Cuenta",
      discordSub: "Pregunta al equipo y a otros miembros",
      copyEmail: "Copiar {{email}}",
      copied: "Correo copiado",
      faq: "Preguntas frecuentes",
      faqSub: "Respuestas rápidas sobre tiendas, ofertas y pagos",
    },
  },
};
